export const timezone = process.env.VUE_APP_TIMEZONE ?? '';
export const ticketingUrl = process.env.VUE_APP_TICKETING_URL ?? '';
export const routeInformationUrl = process.env.VUE_APP_ROUTE_INFO_URL ?? '';
export const timetableResultsUrl = process.env.VUE_APP_TIMETABLE_RESULT_URL ?? '';
export const timetableBackupUrl = process.env.VUE_APP_TIMETABLE_BACKUP_URL ?? '';
export const smsAlertSignupUrl = process.env.VUE_APP_SMS_SIGNUP_URL ?? '';
export const mobileAppDownloadUrl = process.env.VUE_APP_MOBILE_APP_DOWNLOAD_URL ?? '';
export const umbracoBaseUrl = process.env.VUE_APP_UMBRACO_CONSUMER_BASE || '';
export const stayUpdatedUrl = process.env.VUE_APP_STAY_UPDATED_URL || '';
export const assetBaseUrl = process.env.VUE_APP_ASSETS_BASE_URL || '';
